export default "__VITE_ASSET__a01b00cb__"